import type { ReactNode } from "react";

export const ContentContainer = (props: {
	children: ReactNode;
}) => {
	return (
		<div className="w-full mx-auto py-6 md:py-8 text-white">
			{props.children}
		</div>
	);
};
